<li
  *ngIf="!!total"
  class="fls-0-0 cf-primary-rev fld-row ai-ctr pwt-1 vwmx-p100"
>
  <span>Flock Proration</span>
  <span class="fls-1-1"></span>
  <myqq-price [price]="total || ''"></myqq-price>
</li>
